import { render, staticRenderFns } from "./gailan.vue?vue&type=template&id=46f5283b&"
import script from "./gailan.vue?vue&type=script&lang=ts&"
export * from "./gailan.vue?vue&type=script&lang=ts&"
import style0 from "./gailan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports